import { Injectable } from '@angular/core';
import { INotesDetails, ISectionData, SectionIds } from '@modeso/aumico-lib-annualreport-fe';
import { EMPTY_ARRAY_LENGTH } from '@modeso/aumico-lib-core-fe';
import { ITableOfContentEntry } from '../../../interfaces/table-of-content-entry.interface';

@Injectable({ providedIn: 'root' })
export class TocService {
    public getTableOfContentEntries(
        orderedSectionsTitles: string[],
        orderedSectionsIds: SectionIds[],
        complementaryReportsAsAppendix: ISectionData[],
        complementaryReports: ISectionData[],
        notesDetails: INotesDetails[],
    ): ITableOfContentEntry[] {
        const tableOfContentEntries: ITableOfContentEntry[] = [];

        const complementaryReportsAsAppendixWithShowTocOn = complementaryReportsAsAppendix.filter(
            (report) => report.showInTOC,
        );

        let tocIndex = 0;

        orderedSectionsIds.forEach((sectionId, index) => {
            if (
                sectionId == SectionIds.APPENDIX &&
                complementaryReportsAsAppendixWithShowTocOn.length === EMPTY_ARRAY_LENGTH
            ) {
                return;
            }

            if (sectionId.includes(SectionIds.COMPLEMENTARY_REPORT)) {
                const complementaryReportIndex = this.extractNumber(sectionId);

                if (
                    complementaryReports[complementaryReportIndex] != null &&
                    complementaryReports[complementaryReportIndex].showInTOC === false
                ) {
                    return;
                }
            }

            tableOfContentEntries.push({
                id: sectionId,
                labelOrLabelKey: orderedSectionsTitles[index],
                pageNumberPlaceHolder: this.getPlaceHolderFromSectionId(sectionId),
                isLocalized: true,
            });

            if (sectionId === SectionIds.NOTES) {
                tableOfContentEntries[tocIndex].subItems = notesDetails;
            }
            tocIndex++;
        });

        return tableOfContentEntries;
    }

    private getPlaceHolderFromSectionId(sectionId: string): string {
        return `###section#${sectionId}###`;
    }

    private extractNumber(id: string): number | null {
        const match = id.match(/\d+$/);
        return match ? parseInt(match[0], 10) : null;
    }
}
